import {
	Button,
	Checkbox,
	Divider,
	FormControlLabel,
	Grid,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	TextField,
	Typography,
} from '@material-ui/core';

const ImpersonateButton = ({ onClick }) => {
	return (
		<Button variant="contained" color="primary" onClick={onClick}>
			Impersonate
		</Button>
	);
};

const GenerateCodeButton = ({ onClick }) => {
	return (
		<Button variant="contained" color="secondary" onClick={onClick}>
			Generate Code
		</Button>
	);
};

export function ImpersonationTable(props) {
	const {
		companyKey,
		classes,
		handleEmployeeFilterChange,
		handleOnlyMobileChange,
		rowsPerPage,
		employeeList,
		employeeCount,
		employeePage,
		setEmployeePage,
		requestOtp,
		setShouldOpenPestPacImpersonation,
	} = props;

	const handleImpersonate = (employeeId) => {
		setShouldOpenPestPacImpersonation(true);
		requestOtp(companyKey, employeeId);
	};

	const handleGenerateCode = (employeeId) => {
		requestOtp(companyKey, employeeId);
	};

	return (
		<Grid item style={{ minWidth: '1000px' }}>
			<Grid container>
				<Paper style={{ width: '100%' }}>
					<Grid item>
						<Grid
							container
							justifyContent="space-between"
							alignItems="flex-end"
							className={classes.form}
						>
							<Typography variant="h5">Impersonation</Typography>
							<Grid item>
								<Grid container alignItems="flex-end" style={{ gap: '15px' }}>
									<TextField
										label="Search"
										onChange={handleEmployeeFilterChange}
										placeholder="Search..."
										style={{ width: '150px' }}
									/>
									<FormControlLabel
										control={
											<Checkbox
												onChange={handleOnlyMobileChange}
												inputProps={{ 'aria-label': 'Only Mobile Users' }}
												style={{ padding: '0px' }}
											/>
										}
										label="Show Only Mobile Users"
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid item>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>Username</TableCell>
									<TableCell>First/Last Name</TableCell>
									<TableCell>WW Account Email</TableCell>
									<TableCell>Actions</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{employeeList.map((employee) => {
									const {
										employeeId,
										username,
										fullName,
										workWaveAccount,
										isMobileUser,
									} = employee;
									return (
										<TableRow key={employeeId}>
											<TableCell>{username}</TableCell>
											<TableCell>{fullName}</TableCell>
											<TableCell>{workWaveAccount}</TableCell>
											<TableCell>
												<Grid
													container
													justifyContent="space-between"
													alignItems="center"
												>
													<ImpersonateButton
														onClick={(_) =>
															handleImpersonate(employeeId)
														}
													>
														Impersonate
													</ImpersonateButton>
													{isMobileUser && (
														<>
															<Divider
																orientation="vertical"
																flexItem
															/>
															<GenerateCodeButton
																onClick={(_) =>
																	handleGenerateCode(employeeId)
																}
															>
																Generate Code
															</GenerateCodeButton>
														</>
													)}
												</Grid>
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
						<TablePagination
							rowsPerPageOptions={[rowsPerPage]}
							component="div"
							count={employeeCount}
							rowsPerPage={rowsPerPage}
							page={employeePage}
							backIconButtonProps={{
								'aria-label': 'Previous Employee Page',
							}}
							nextIconButtonProps={{
								'aria-label': 'Next Employee Page',
							}}
							onPageChange={(event, page) => setEmployeePage(page)}
						/>
					</Grid>
				</Paper>
			</Grid>
		</Grid>
	);
}
